<template>
    <div v-show="visible">
        <el-dialog title="查看附件" :close-on-click-modal="false" v-loading="loading"  :visible.sync="visible" :before-close="dialogClose" width="600px">
            <el-table
                :data="data"
                style="width: 100%;margin-bottom: 20px;"
                row-key="roleId"
                height="200"
                v-loading="loading"
                element-loading-background = "rgba(255, 255,255,0.7)"
                element-loading-text = "数据正在加载中..."
                border fit highlight-current-row>
                <el-table-column type="index" label="序号" width="55" :index="indexMethod"> </el-table-column>
                <el-table-column prop="" label="附件">
                    <template slot-scope="scope">
                        <div v-if="scope.row.fileType == 1">
                            <el-popover
                                placement="right"
                                title=""
                                trigger="hover">
                                <img :src="scope.row.url" lazy="loading"
                                    style="height:550px; width:550px"/>
                                <img slot="reference" :src="scope.row.url"  lazy="loading" :alt="scope.row.url" style="height: 100px;width:100px">
                            </el-popover>
                        </div>
                        <div v-else-if="scope.row.fileType == 3">
                            <el-button type="text" @click="lookVideo(scope.row)">点击查看视频</el-button>
                        </div>
                        <div v-else-if="scope.row.fileType == 2">
                            <a target="_blank" :href="scope.row.url">点击查看录音</a>
                        </div>
                        <div v-else>
                            无
                        </div>
                    </template>
                </el-table-column>
            </el-table> 
            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="visible=false">关闭</el-button>
            </span>    
        </el-dialog>
        <!--查看人脸视频 -->
        <div v-if="videoVisible">
            <lookVideo ref="lookVideo"></lookVideo>
        </div>
    </div>
</template>

<script>
    import http from '../../../../common/http';
    import lookVideo from '../../sys/user/Video';
    import {banBackSpace} from '../../../../common/preventBackspace';// backspace退格

    export default {
        name:"",
        data(){
            return{
                visible:false,
                loading:false,
                videoVisible:false,
                form:{
                    deptId:"",
                    evaluateDetailId:""
                },
                data:[]

            }
        },
        components: {
            lookVideo
        },
        created:function () {
        },
        mounted:function () {
            document.onkeypress = banBackSpace
            document.onkeydown = banBackSpace
        },
        methods:{
            init(deptId,evaluateDetailId){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.deptId=deptId;
                this.form.evaluateDetailId=evaluateDetailId;

                this.getData();
            },
            indexMethod(index) {
                return index+1;
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            getData(){
                this.loading=true;
                let url  = this.evaluateDetailFileListUrl;
                let data = {
                    deptId:this.form.deptId,
                    evaluateDetailId:this.form.evaluateDetailId
                };
                // console.log(data);
                this.apiPost(url,data).then((res) => {
                    console.log(res.data);
                    if(res.status==200){
                       this.data = res.data.list;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                },(err)=>{
                    console.log(err);
                    this.loading=false;
                });
            },
            lookVideo(row){
                this.videoVisible = true;
                this.$nextTick(() => {
                    this.$refs['lookVideo'].init(row.url);
                })
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
     .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/mobileset/evaluate/EvaluateFile.vue